import { BackgroundContainer } from "@client/controls/Style/Background/container";
import withIsVisibleHOC from "@client/hocs/withIsVisible";
import { type EnhanceWidget } from "@client/types";
import * as React from "react";

import { getWidgetDataAttributes } from "../lib";
import "./style.less";

export type FooterProps = FooterContentProps & {
  enhance?: EnhanceWidget;
};

export interface FooterContentProps {
  className: string;
  isVisible: boolean;
  style: React.CSSProperties;
  children: any;
}

const Content = React.forwardRef((props: FooterContentProps, ref: React.RefObject<any>) => (
  <footer
    ref={ref}
    {...getWidgetDataAttributes("footer", "Footer")}
    id="footer"
    className={props.className}
    style={props.style}
    data-title="Footer"
  >
    <BackgroundContainer containerSelector="#footer" prefix="footer" />

    {props.children}
  </footer>
));

const Footer = ({ enhance, ...props }: FooterProps) => {
  const EnhancedContent = React.useMemo(() => (enhance ? enhance(Content) : null), [enhance]);
  return EnhancedContent ? <EnhancedContent {...props} id="footer" /> : <Content {...props} />;
};

export default withIsVisibleHOC<FooterProps>(Footer);
